import { createContext, useContext } from 'react';

export const CurrentLocaleContext = createContext<UserLocale>('en');

export function useCurrentLocale() {
  const currentLocale = useContext(CurrentLocaleContext);
  return { currentLocale };
}
